var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    fill: "#e39ff6",
    viewBox: "0 0 556.42 556.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m508.09 13.5c3.726-7.457-7e-3 -13.5-8.345-13.5h-205.77c-19.045 6e-3 -44.079 38.363-56.512 52.262-21.87 24.449-186.59 207.55-187.78 209.93-3.727 7.458-3.727 19.544 0 27.001l222.46 253.73c3.727 7.458 13.507 13.501 21.843 13.501h205.77c8.335 0 12.071-6.043 8.345-13.501l-222.46-253.73c-3.728-7.457-3.728-19.544 0-27.001l222.46-248.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.7a33f5b9d79c12e1b4e2558423e3767b.svg";
export { ForwardRef as ReactComponent };